import { render, staticRenderFns } from "./MappingEditor.vue?vue&type=template&id=71b391bf&scoped=true&"
import script from "./MappingEditor.vue?vue&type=script&lang=js&"
export * from "./MappingEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b391bf",
  null
  
)

export default component.exports